import { CoodeSdk, CoodeSdkOptions, Environments } from "@coode/fe-sdk";

const coodeSdkPluginConfiguration: CoodeSdkOptions = {
    environment: process.env.VUE_APP_ENVIRONMENT as Environments,
    auth: {
        backEndBaseUrl: process.env.VUE_APP_VUE_UI_API_PML_URL,
        backEndScope: `api://${process.env.VUE_APP_CLIENT_ID}/coode`,
        msal: {
            auth: {
                clientId: process.env.VUE_APP_CLIENT_ID || "",
                authority: process.env.VUE_APP_AUTHORITY_URL,
                redirectUri: window.location.origin,
                postLogoutRedirectUri: `${window.location.origin}/authorization/logged-out.html`,
            },
            cache: {
                cacheLocation: "sessionStorage",
            },
            system: {
                loggerOptions: 0 as any,
            },
        },
    },
    insights: {
        appInsightsConnectionString:
            process.env.VUE_APP_APPINSIGHT_CONNECTION_STRING,
    },
    phraseProjectId: process.env.VUE_APP_PHRASE_PROJECT_ID,
    phraseProjectDefaultLanguage: 'en-GB',
};

export const sdk = new CoodeSdk(coodeSdkPluginConfiguration);
